import * as Yup from 'yup';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Formik } from 'formik';
import { FaMeta } from 'react-icons/fa6';

import Button, { ButtonType } from 'legacy/common/components/button/Button';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import Field from 'legacy/common/components/wysiwyg-form/Field';

interface MetaPixelModalProps {
  initialValues: { metaPixelId: string };
  onClose: () => void;
  onSave: (label: string) => void;
}

const MetaPixelSchema = Yup.object().shape({
  metaPixelId: Yup.string()
});

const MetaPixelModal: React.FC<MetaPixelModalProps> = ({
  initialValues,
  onClose,
  onSave
}) => {
  const { t } = useTranslation(['events']);
  const onSubmit = (values) => {
    onSave(values.metaPixelId);
    onClose();
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      enableReinitialize
      validationSchema={MetaPixelSchema}
    >
      {({ submitForm }) => (
        <Modal
          type={ModalType.SMALL}
          onClose={onClose}
          autoHeight
          visible
          icon={<FaMeta size={20} />}
          title={t('events:settings.metaPixel.modal.title')}
          renderFooter={() => (
            <Button type={ButtonType.Primary} onClick={submitForm}>
              {t('events:settings.metaPixel.modal.saveButton')}
            </Button>
          )}
        >
          <p className="px-6 pt-6 text-base font-normal">
            {t('events:settings.metaPixel.modal.description')}
          </p>
          <div className="px-4 pt-6">
            <Field
              type="text"
              label={t('events:settings.metaPixel.modal.pixelIdLabel')}
              id="metaPixelId"
              name="metaPixelId"
              clearable
              placeholder={t(
                'events:settings.metaPixel.modal.pixelIdPlaceholder'
              )}
            />
          </div>
        </Modal>
      )}
    </Formik>
  );
};

export default MetaPixelModal;
